import React, { useState, useEffect } from 'react';
import {  update_admin, get_all_adminsprovider_types,get_all_adminsproviders } from "../../../services/AuthServices";
import './AdminManagement.css';
import AdminsAccountCreationPage from './Adminsaccountcreationpage';
import Useraccounts from './Useraccounts';
import ProviderTypeBulkOperations from './CreateProviderTypeForm';

const AdminManagement = () => {
  const [admins, setAdmins] = useState([]);
  const [userlist, setuserlist] = useState([]);
  const [userlistLoading, setUserlistLoading] = useState(false);
  const [loading, setLoading] = useState(true);
    const [selectedType, setSelectedType] = useState(''); 
  const [showEditModal, setShowEditModal] = useState(false);
  const [currentAdmin, setCurrentAdmin] = useState(null);
  const [filterType, setFilterType] = useState('Admin'); // Default filter for Admin type
  
  // Form states
  const [formData, setFormData] = useState({
    type: '',
    description: '',
    isActive: true,
    serviceName: '',
    serviceDescription: '',
    isServiceActive: true
  });
  
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  
  // Fetch admins on component mount
  useEffect(() => {
    fetchAdmins();
  }, [filterType]);
  
  // Fetch admins from API
  const fetchAdmins = async () => {
    try {
      setLoading(true);
      const data = await get_all_adminsprovider_types();
      
      
      
      setAdmins(data);
    } catch (error) {
      console.error('Error fetching admins:', error);
      alert('Failed to load admins');
    } finally {
      setLoading(false);
    }
  };


// Update the useEffect (around line 55-80) to handle errors better:
useEffect(() => {
  const fetchuserlist = async () => {
    // Don't fetch if selectedType is undefined
    if (selectedType === undefined) return;
    
    setUserlistLoading(true);
    try {
      console.log("Fetching user list for type:", selectedType);
      
      // If selectedType is empty string, pass 'admin' as default
      const typeToSend = selectedType || 'admin';
      
      const providerlist = await get_all_adminsproviders(typeToSend);
      console.log("Received provider list:", providerlist);
      
      // Ensure we always have an array
      setuserlist(Array.isArray(providerlist) ? providerlist : []);
      
    } catch (error) {
      console.error("Error fetching user list:", error.message);
      setuserlist([]); // Clear list on error
      alert(`Error loading users: ${error.message}`);
    } finally {
      setUserlistLoading(false);
    }
  }
  
  fetchuserlist();
}, [selectedType]);
  

const handlecreate_providetype = async() =>{
  try {
    
  } catch (error) {
    
  }
}
  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
    
    // Clear error for this field
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };
  
  // Validate form
  const validateForm = () => {
    const newErrors = {};
    
    if (!formData.type.trim()) {
      newErrors.type = 'Type is required';
    }
    
    if (!formData.description.trim()) {
      newErrors.description = 'Description is required';
    }
    
    if (formData.serviceName && !formData.serviceDescription.trim()) {
      newErrors.serviceDescription = 'Service description is required when service name is provided';
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  

  
  // Handle edit admin
  const handleEditAdmin = (admin) => {
    setCurrentAdmin(admin);
    setFormData({
      type: admin.type,
      description: admin.description,
      isActive: admin.isActive,
      serviceName: admin.serviceName || '',
      serviceDescription: admin.serviceDescription || '',
      isServiceActive: admin.isServiceActive !== undefined ? admin.isServiceActive : true
    });
    setShowEditModal(true);
  };
  
  // Handle update admin
  const handleUpdateAdmin = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }
    
    setIsSubmitting(true);
    try {
      const updateData = {
        ...formData,
        id: currentAdmin.id,
        isActive: Boolean(formData.isActive),
        isServiceActive: Boolean(formData.isServiceActive)
      };
      
      await update_admin(updateData);
      alert('Admin updated successfully!');
      setShowEditModal(false);
      resetForm();
      fetchAdmins(); // Refresh list
    } catch (error) {
      console.error('Error updating admin:', error);
      alert('Failed to update admin');
    } finally {
      setIsSubmitting(false);
    }
  };
    const handleTypeChange = (e) => {
  const newType = e.target.value;
  console.log("Type changed to:", newType);
  setSelectedType(newType);
};
  // Reset form
  const resetForm = () => {
    setFormData({
      type: '',
      description: '',
      isActive: true,
      serviceName: '',
      serviceDescription: '',
      isServiceActive: true
    });
    setErrors({});
    setCurrentAdmin(null);
  };
  
  // Toggle admin active status
  const toggleAdminStatus = async (admin) => {
    if (window.confirm(`Are you sure you want to ${admin.isActive ? 'deactivate' : 'activate'} this admin?`)) {
      try {
        const updateData = {
          id: admin.id,
          type: admin.type,
          description: admin.description,
          isActive: !admin.isActive,
          serviceName: admin.serviceName,
          serviceDescription: admin.serviceDescription,
          isServiceActive: admin.isServiceActive
        };
        
        await update_admin(updateData);
        alert(`Admin ${admin.isActive ? 'deactivated' : 'activated'} successfully!`);
        fetchAdmins(); // Refresh list
      } catch (error) {
        console.error('Error toggling admin status:', error);
        alert('Failed to update admin status');
      }
    }
  };
  // Add this function in your AdminManagement component, after other handler functions:

// Handle user update from Useraccounts component
const handleUsersUpdate = (updatedUsers) => {
  // Update the userlist state with the updated users
  setuserlist(updatedUsers);
};

// Handle refresh of user list (optional, but useful)
const refreshUserList = () => {
  if (selectedType !== undefined) {
    const typeToSend = selectedType || 'admin';
    get_all_adminsproviders(typeToSend)
      .then(providerlist => {
        console.log("Refreshed user list:", providerlist);
        setuserlist(providerlist || []);
      })
      .catch(error => {
        console.error("Error refreshing user list:", error.message);
        setuserlist([]);
      });
  }
};
  // Get unique types for filter
  const getUniqueTypes = () => {
    const types = [...new Set(admins.map(admin => admin.type))];
    return types;
  };
  
  // Format date
  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };
  
  if (loading) {
    return (
      <div className="admin-management loading">
        <div className="spinner"></div>
        <p>Loading admins...</p>
      </div>
    );
  }
  
  return (
    <>
    <div className="admin-management">
      <div className="admin-header">
        <h1>Admin Management</h1>
        <div className="header-actions">
            <ProviderTypeBulkOperations 
      existingTypes={admins}
      onSuccess={fetchAdmins} // Refresh the list after bulk operations
    />
          <div className="filter-section">
            <label htmlFor="typeFilter">Filter by Type:</label>
            <select
              id="typeFilter"
              value={filterType}
              onChange={(e) => setFilterType(e.target.value)}
              className="filter-select"
            >
              <option value="">All Types</option>
              {getUniqueTypes().map(type => (
                <option key={type} value={type}>{type}</option>
              ))}
            </select>
          </div>
       
        </div>
      </div>
      
      {/* Admins Table */}
      <div className="admins-table-container">
        {admins.length === 0 ? (
          <div className="no-data">
            <p>No admins found{filterType && ` for type: ${filterType}`}</p>
          </div>
        ) : (
          <table className="admins-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Type</th>
                <th>Description</th>
                <th>Service Name</th>
                <th>Status</th>
                <th>Created</th>
                <th>Updated</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {admins.map(admin => (
                <tr key={admin.id} className={!admin.isActive ? 'inactive' : ''}>
                  <td>{admin.id}</td>
                  <td>
                    <span className="type-badge">{admin.type}</span>
                  </td>
                  <td className="description-cell">
                    {admin.description}
                    {admin.serviceDescription && (
                      <div className="service-description">
                        <small>{admin.serviceDescription}</small>
                      </div>
                    )}
                  </td>
                  <td>{admin.serviceName || '-'}</td>
                  <td>
                    <span className={`status-badge ${admin.isActive ? 'active' : 'inactive'}`}>
                      {admin.isActive ? 'Active' : 'Inactive'}
                    </span>
                    {admin.serviceName && (
                      <span className={`status-badge service-status ${admin.isServiceActive ? 'active' : 'inactive'}`}>
                        Service: {admin.isServiceActive ? 'Active' : 'Inactive'}
                      </span>
                    )}
                  </td>
                  <td>{formatDate(admin.createdAt)}</td>
                  <td>{formatDate(admin.updatedAt)}</td>
                  <td>
                    <div className="action-buttons">
                      <button
                        className="btn-edit"
                        onClick={() => handleEditAdmin(admin)}
                      >
                        Edit
                      </button>
                      <button
                        className={`btn-toggle ${admin.isActive ? 'deactivate' : 'activate'}`}
                        onClick={() => toggleAdminStatus(admin)}
                      >
                        {admin.isActive ? 'Deactivate' : 'Activate'}
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
      
      {/* Create Admin Modal */}
  
      
      {/* Edit Admin Modal */}
      {showEditModal && currentAdmin && (
        <div className="modal-overlay">
          <div className="modal">
            <div className="modal-header">
              <h2>Edit Admin: {currentAdmin.type}</h2>
              <button 
                className="close-btn"
                onClick={() => {
                  setShowEditModal(false);
                  resetForm();
                }}
              >
                &times;
              </button>
            </div>
            <form onSubmit={handleUpdateAdmin} className="admin-form">
              <div className="form-group">
                <label htmlFor="edit-type">Type *</label>
                <input
                  type="text"
                  id="edit-type"
                  name="type"
                  value={formData.type}
                  onChange={handleInputChange}
                  className={errors.type ? 'error' : ''}
                />
                {errors.type && <span className="error-message">{errors.type}</span>}
              </div>
              
              <div className="form-group">
                <label htmlFor="edit-description">Description *</label>
                <textarea
                  id="edit-description"
                  name="description"
                  value={formData.description}
                  onChange={handleInputChange}
                  rows="3"
                  className={errors.description ? 'error' : ''}
                />
                {errors.description && <span className="error-message">{errors.description}</span>}
              </div>
              
              <div className="form-group">
                <label htmlFor="edit-serviceName">Service Name</label>
                <input
                  type="text"
                  id="edit-serviceName"
                  name="serviceName"
                  value={formData.serviceName}
                  onChange={handleInputChange}
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="edit-serviceDescription">Service Description</label>
                <textarea
                  id="edit-serviceDescription"
                  name="serviceDescription"
                  value={formData.serviceDescription}
                  onChange={handleInputChange}
                  rows="3"
                  className={errors.serviceDescription ? 'error' : ''}
                />
                {errors.serviceDescription && <span className="error-message">{errors.serviceDescription}</span>}
              </div>
              
              <div className="form-row">
                <div className="form-group checkbox-group">
                  <label>
                    <input
                      type="checkbox"
                      name="isActive"
                      checked={formData.isActive}
                      onChange={handleInputChange}
                    />
                    <span>Active</span>
                  </label>
                </div>
                
                {formData.serviceName && (
                  <div className="form-group checkbox-group">
                    <label>
                      <input
                        type="checkbox"
                        name="isServiceActive"
                        checked={formData.isServiceActive}
                        onChange={handleInputChange}
                      />
                      <span>Service Active</span>
                    </label>
                  </div>
                )}
              </div>
              
              <div className="modal-actions">
                <button
                  type="button"
                  className="btn-cancel"
                  onClick={() => {
                    setShowEditModal(false);
                    resetForm();
                  }}
                  disabled={isSubmitting}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn-submit"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? 'Updating...' : 'Update Admin'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
    <AdminsAccountCreationPage providers={admins} />
    <div className='usercontainerdata'>
          <div className="filter-section">
        <div className="filter-dropdown">
          <label htmlFor="type-filter">Filter by Type:</label>
          <select 
            id="type-filter"
            value={selectedType}
            onChange={handleTypeChange}
            className="filter-select"
          >
            <option value="">All Types</option>
            {getUniqueTypes().map((type) => (
              <option key={type} value={type}>
                {type}
              </option>
            ))}
          </select>
        </div>
        
        {/* You can also add a button to clear filter */}
        {selectedType && (
          <button 
            className="clear-filter-btn"
            onClick={() => setSelectedType('')}
          >
            Clear Filter
          </button>
        )}
      </div>
    

{userlistLoading ? (
  <div className="loading-container">
    <div className="spinner"></div>
    <p>Loading users...</p>
  </div>
) : (
  <Useraccounts 
    userdata={userlist}
    onupdate={handleUsersUpdate}
  />
)}
    </div>
    </>
  );
};

export default AdminManagement;